<template>
  <input type="checkbox" :name="name" value="1" />
</template>

<script>
export default {
  props: {
    name: String,
  },
}
</script>
